$(document).ready(function() {
    // Select the button that controls the panel
    const viewContentButton = document.querySelector('button[data-controls^="panel-view-more-"]');
    // Select the panel that is controlled by the button
    const panel = document.querySelector('[id^="panel-view-more-"]');

    // Check if both the button and panel exist
    if (viewContentButton !== null && panel !== null) {
        // Update the tabindex of links within the panel
        updateTabIndex(panel);

        // Add a click event listener to the button to update the tabindex
        viewContentButton.addEventListener('click', () => updateTabIndex(panel));

        // Add a keydown event listener to the button to handle space and enter keys
        viewContentButton.addEventListener('keydown', (event) => {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault(); // Prevent default action for space and enter keys
                updateTabIndex(panel); // Update the tabindex of links within the panel
            }
        });
    }
});

/**
 * This function adds the tabindex=-1 attribute for links within a content area.
 * This ensures that users navigating the page with the Tab key will skip these links
 * if the content is not fully visible. When the content is fully extended, the tabindex
 * attribute is removed to allow normal tab navigation.
 **/
function updateTabIndex(panel) {
    // Select all links within the panel
    const links = panel.querySelectorAll('a');

    // Check if the panel is hidden
    if (panel.getAttribute('aria-hidden') === 'true') {
        // Add tabindex=-1 to all links to make them non-focusable
        links.forEach(link => {
            link.setAttribute('tabindex', '-1');
        });
    } else {
        // Remove the tabindex attribute to make links focusable
        links.forEach(link => {
            link.removeAttribute('tabindex');
        });
    }
}

//Add focus on the close modal button when the modal is opened with Enter key.
const openButton = document.querySelector('.button[data-dialog-open="calendarShare"]');
const closeButton = document.querySelector('button[data-dialog-close="calendarShare"][aria-label="Close modal"]');

if(openButton && closeButton) {
    openButton.addEventListener('keydown', function (event) {
        if (event.key === "Enter" || event.key === " ") {
            const focusInterval = setInterval(() => {
                if (closeButton) {
                    closeButton.focus();
                    clearInterval(focusInterval);
                }}, 50);
        }
    });
}